import React from "react";
import styled from "styled-components";
import { spacing, typography, transitions } from "../../styles/designSystem";

const MetricsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: ${spacing[600]};
    margin: ${spacing[800]} 0;
`;

const MetricCard = styled.div`
    /* The value is sized against this card, not the viewport, so a long single
       word ("MILLIONS") shrinks to fit its own column instead of spilling past
       the border on a three-across grid. */
    container-type: inline-size;
    background: ${({ theme }) => theme.cardBackground};
    border: 1px solid ${({ theme }) => theme.borderLight};
    border-left: 2px solid ${({ accentColor, theme }) => accentColor || theme.primary};
    padding: ${spacing[600]};
    box-shadow: inset 0 0 30px rgba(0, 0, 0, 0.5);
    transition: ${transitions.base};

    &:hover {
        border-color: ${({ accentColor, theme }) => accentColor || theme.primary};
        box-shadow: 0 0 18px ${({ theme }) => theme.glowSoft},
                    inset 0 0 30px rgba(0, 0, 0, 0.5);
    }
`;

const MetricValue = styled.div`
    font-family: ${typography.fontFamily.display};
    text-transform: uppercase;
    letter-spacing: ${typography.letterSpacing.wide};
    text-shadow: 0 0 12px currentColor;
    font-size: clamp(${typography.fontSize[500]}, 18cqi, ${typography.fontSize[800]});
    font-weight: ${typography.fontWeight.bold};
    /* Last-resort guard: a word longer than the card breaks rather than overflows. */
    overflow-wrap: anywhere;
    color: ${({ accentColor, theme }) => accentColor || theme.primary};
    margin-bottom: ${spacing[200]};
    line-height: ${typography.lineHeight.tight};
`;

const MetricLabel = styled.div`
    font-family: ${typography.fontFamily.display};
    text-transform: uppercase;
    letter-spacing: ${typography.letterSpacing.wide};
    font-size: ${typography.fontSize[200]};
    color: ${({ theme }) => theme.textSecondary};
    line-height: ${typography.lineHeight.snug};
    font-weight: ${typography.fontWeight.medium};
`;

const MetricDescription = styled.p`
    font-size: ${typography.fontSize[200]};
    color: ${({ theme }) => theme.text};
    margin: ${spacing[300]} 0 0 0;
    line-height: ${typography.lineHeight.relaxed};
`;

const MetricsCard = ({ metrics }) => (
    <MetricsGrid>
        {metrics.map((metric, index) => (
            <MetricCard key={index} accentColor={metric.color}>
                <MetricValue accentColor={metric.color}>{metric.value}</MetricValue>
                <MetricLabel>{metric.label}</MetricLabel>
                {metric.description && <MetricDescription>{metric.description}</MetricDescription>}
            </MetricCard>
        ))}
    </MetricsGrid>
);

export default MetricsCard;